export default {
      id: "icon-menu-chevron-usage",
      viewBox: "0 0 19 10",
      url: "../icon/" + "icons.svg#icon-menu-chevron-usage",
      toString: function () {
        return this.url;
      }
    }